/** ----------------~ S P I N N E R  ~----------------- */

/**
 * Initializes a new spinner control.
 *
 * @param {element} The control's root element.
 * @copyright Copyright (c) 2013 Nationale Nederlanden
 */

nn.component.Spinner = function () {
  // Initialize
  this.init();
};

$.extend(nn.component.Spinner.prototype, {
  /**
   * Initialize the Spinner compnent
   */
  init: function () {},
  setContent: function (_content) {
    this.content = $(_content);
  },
  show: function () {
    nn.globals.glass.show({ locked: true });
    this.spinner = this.content.appendTo('body');
  },
  hide: function () {
    this.spinner.remove();

    nn.globals.glass.hide();
    nn.globals.glass.unlock();
  },
  getElement: function () {
    return this.spinner;
  },
  centerContent: function () {
    this.content.css({
      'margin-left': '-' + this.content.outerWidth() / 2 + 'px',
      'margin-right': '-' + this.content.outerHeight() / 2 + 'px',
    });
  },
});
